import ScrollReveal from '../shared/ScrollReveal'
import GradientText from '../shared/GradientText'
import './StorySection.css'

const steps = [
  {
    num: '01',
    tag: '↗',
    title: 'Manual export',
    body: 'Owner exports CSVs by hand, every few weeks.'
  },
  {
    num: '02',
    tag: 'AI',
    title: 'Generic AI',
    body: 'Fed into a chatbot never trained on PV physics.'
  },
  {
    num: '03',
    tag: '✓',
    title: 'Polished report',
    body: 'Reads well. Owner sees green. Moves on.'
  }
]

export default function StorySection() {
  return (
    <section className="story-section" id="story">
      <div className="container">
        <ScrollReveal className="story-header">
          <span className="story-eyebrow">// A FAMILIAR STORY</span>
          <h2 className="story-title">
            Looks <GradientText gradient="solar">solid.</GradientText>
            <br />
            Actually <GradientText gradient="solar">superficial.</GradientText>
          </h2>
        </ScrollReveal>

        <div className="story-grid">
          {steps.map((step, i) => (
            <ScrollReveal key={step.num} delay={0.1 * i} className="story-step-wrap">
              <div className="story-step">
                <div className="story-step-header">
                  <span className="story-step-num">{step.num}</span>
                  <span className="story-step-tag">{step.tag}</span>
                </div>
                <h3 className="story-step-title">{step.title}</h3>
                <p className="story-step-body">{step.body}</p>
              </div>
              {i < steps.length - 1 && <span className="story-arrow">→</span>}
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal delay={0.4}>
          <div className="story-reality">
            <span className="story-reality-label">REALITY</span>
            <p className="story-reality-text">
              Issues <span className="story-reality-emphasis">stay buried.</span> Until they don't.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}
